import { FieldValues, useFormContext } from 'react-hook-form';
import { UseExtendedFormReturn } from '../type';

export default function useExtendedFormContext<
  TFieldValues extends FieldValues = FieldValues,
  TContext = AnyValue
>(): UseExtendedFormReturn<TFieldValues, TContext> {
  return useFormContext<TFieldValues>() as unknown as UseExtendedFormReturn<TFieldValues, TContext>;
}
